import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=78980970&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"
import style1 from "./Help.vue?vue&type=style&index=1&id=78980970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78980970",
  null
  
)

export default component.exports